/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredCertificateDtoTimeToExpirationDuration
 */
export interface MonitoredCertificateDtoTimeToExpirationDuration {
    /**
     * 
     * @type {number}
     * @memberof MonitoredCertificateDtoTimeToExpirationDuration
     */
    seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoredCertificateDtoTimeToExpirationDuration
     */
    nano?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpirationDuration
     */
    negative?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredCertificateDtoTimeToExpirationDuration
     */
    zero?: boolean;
}

export function MonitoredCertificateDtoTimeToExpirationDurationFromJSON(json: any): MonitoredCertificateDtoTimeToExpirationDuration {
    return MonitoredCertificateDtoTimeToExpirationDurationFromJSONTyped(json, false);
}

export function MonitoredCertificateDtoTimeToExpirationDurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredCertificateDtoTimeToExpirationDuration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'seconds': !exists(json, 'seconds') ? undefined : json['seconds'],
        'nano': !exists(json, 'nano') ? undefined : json['nano'],
        'negative': !exists(json, 'negative') ? undefined : json['negative'],
        'zero': !exists(json, 'zero') ? undefined : json['zero'],
    };
}

export function MonitoredCertificateDtoTimeToExpirationDurationToJSON(value?: MonitoredCertificateDtoTimeToExpirationDuration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'seconds': value.seconds,
        'nano': value.nano,
        'negative': value.negative,
        'zero': value.zero,
    };
}

